export const formatNum = (number: number): string => {
    if (number < 1000) {
        return number.toFixed(1);
    } else if (number < 1000000) {
        const k = (number / 1000).toFixed(1);
        return k + 'K';
    } else if (number < 1000000000) {
        const m = (number / 1000000).toFixed(1);
        return m + 'M';
    } else if (number >= 1000000000) {
        const b = (number / 1000000000).toFixed(1);
        return b + 'B';
    } else {
        return 'ND';
    }
}